module.exports = __webpack_public_path__ + "static/media/avatar11.b29feb88.png";